export interface ContentProps {
  open: boolean;
  closeModal: () => void;
  email: string;
  membershipNumber: string;
  miles: string;
}
export enum ModalTypes {
  confirmation = 'confirmation',
  success = 'success',
}
